import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Pictures from "../DetailsComponents/Pictures";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomPictures from "../DetailsComponents/BottomPictures";
import Description from "../DetailsComponents/Description";
import StrongPoint from "../DetailsComponents/StrongPoint";
import img1 from "../../../assets/Image/Details9/Photo1.jpg";
import img2 from "../../../assets/Image/Details9/Photo2.jpg";
import img3 from "../../../assets/Image/Details9/Photo3.jpg";
import img4 from "../../../assets/Image/Details9/Photo4.jpg";
import img5 from "../../../assets/Image/Details9/Photo5.jpg";
import img6 from "../../../assets/Image/Details9/Photo6.jpg";

import {
    faArrowLeft,
    faLocation,
    faPaintBrush,
    faRoad,
} from "@fortawesome/free-solid-svg-icons";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const images = [img1, img2, img3, img4, img5];
const images2 = [img1, img2, img3, img4, img5, img6];

const DetailsId9 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const navigate = useNavigate();

    const handleImageClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };
    return (
        <div>
            <div className="px-48 xl:px-28 lg:px-24 md:px-14 sm:px-6">
                <button
                    className="w-10 h-10 mt-1 bg-customGray text-black rounded-full p-2 tansition duration-300 ease-in-out transform hover:text-customPink hover:bg-white hover:scale-125"
                    onClick={() => navigate("/acheter-louer")}
                >
                    <FontAwesomeIcon
                        className="m-auto text-base"
                        icon={faArrowLeft}
                    />
                </button>
                <Pictures
                    title="Maison à rénover"
                    images={images}
                    onImageClick={handleImageClick}
                />
                <BottomPictures
                    place="10 Rue de la République, 86440 Migné-Auxances"
                    state="310 500€"
                />
                <h5 className="text-2xl mt-20 mb-10">Points forts du bien</h5>
                <div className="mb-20 flex justify-around items-center reveal-left lg:flex-wrap gap-8 md:flex-wrap gap-8 sm:flex-wrap gap-8">
                    <StrongPoint
                        icon={faLocation}
                        text="Proche des commerces"
                    />
                    <StrongPoint icon={faRoad} text="N147 à proximité" />
                    <StrongPoint icon={faPaintBrush} text="Travaux" />
                </div>
                <Description
                    text={`Nous vous proposons cette charmante maison de 123m² habitable datant de fin 19ème, située sur une parcelle d'environ 1300m² dans une rue calme.
                        Calme, lumineuse et bien disposée elle se compose au rez de chaussée d'une entrée desservant une pièce de vie, une cuisine séparée aménagée et équipée et un wc. A l'étage vous retrouverez deux spacieuses chambres et une salle de bain.
                        PLUSIEURS ESPACES ENTIEREMENT AMENAGEABLES EN + : Au rez de chaussée, au 1er étage et au 2ème étage vous retrouverez trois espaces entièrement aménageables de 60m² chacun, soit au total 180m² supplémentaires permettant de créer plusieurs chambres, des pièces d'eau et/ou d'agrandir la pièce de vie.
                        Un garage de 70m² et un atelier de 20m² complète ce bien rare le secteur.
                        L'ensemble de la maison donne sur un jardin arboré situé sur l'avant et sur un côté de la maison`}
                />
            </div>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
                    <button
                        className="absolute top-4 right-4 text-white text-2xl"
                        onClick={() => setIsOpen(false)}
                    >
                        &times;
                    </button>
                    <div className="w-8/12 md:w-3/4 lg:w-3-4 sm:w-full">
                        <Carousel
                            selectedItem={photoIndex}
                            showThumbs={true}
                            showStatus={false}
                            swipeable={true}
                            autoPlay={true}
                            interval={4000}
                            infiniteLoop
                            useKeyboardArrows
                            onChange={(index) => setPhotoIndex(index)}
                        >
                            {images2.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={img}
                                        alt={`Show ${index + 1}`}
                                        className="object-contain w-full"
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetailsId9;
